import { PayRequestPayload } from "checkout-query-client/api/types";
import { PaymentType } from "checkout-query-client/types/form-types";
import { buildPostalPayload } from "checkout-query-client/utils/build-payloads/build-base-payload";

export function buildBillingAddress(
  payload: PayRequestPayload,
  paymentType: PaymentType
) {
  const { formFields, merchantSettings, checkoutSessionData } = payload;

  let billingAddress = undefined;
  let billingAddressSameAsShipping = false;
  let billingAddressFromIntentBilling = false;

  if (formFields && merchantSettings) {
    billingAddressSameAsShipping = formFields?.doAddressesMatch === "true";

    billingAddress = buildPostalPayload(
      formFields,
      paymentType,
      payload.paymentMethodId ?? ""
    );

    billingAddressFromIntentBilling =
      Boolean(checkoutSessionData?.billingAddress) &&
      !merchantSettings?.paymentMethods?.cardPaymentMethod
        ?.billingAddressCollection?.enabled;

    // if the shipping address is empty, then don't send the flag "billingAddressSameAsShipping"
    // instead send "billingAddressFromIntentBilling"
    // MSCHECKOUT-7195
    if (billingAddressSameAsShipping && !checkoutSessionData?.shippingAddress) {
      billingAddressFromIntentBilling = true;
      billingAddressSameAsShipping = false;
    }
  }

  return {
    billingAddress,
    billingAddressSameAsShipping,
    billingAddressFromIntentBilling,
  };
}
